import DataBlock, { DataBlockProps } from './DataBlock';

export type { DataBlockProps };
export default DataBlock;
